import { render } from "./PatientSection.vue?vue&type=template&id=7ad4e1cd&scoped=true&lang=pug"
import script from "./PatientSection.vue?vue&type=script&lang=js"
export * from "./PatientSection.vue?vue&type=script&lang=js"

import "./PatientSection.vue?vue&type=style&index=0&id=7ad4e1cd&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ad4e1cd"]])

export default __exports__